var _path, _ellipse;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFavoritePlace(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 17,
    viewBox: "0 0 16 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14286 0.446289C2.51167 0.446289 2 0.957963 2 1.58915V16.2039C2 16.3138 2.11702 16.3841 2.21402 16.3325L7.93161 13.2916C7.97437 13.2689 8.02563 13.2689 8.06838 13.2916L13.786 16.3325C13.883 16.3841 14 16.3138 14 16.2039V1.58915C14 0.957964 13.4883 0.446289 12.8571 0.446289H3.14286ZM8.00001 2.22028C6.34588 2.22028 5 3.56613 5 5.22022C5 7.86653 7.7422 11.023 7.85901 11.1561C7.89463 11.1968 7.94601 11.2201 8.00001 11.2201C8.05813 11.2161 8.10632 11.1963 8.14195 11.155C8.25876 11.0197 11 7.8101 11 5.22022C11 3.56613 9.65414 2.22028 8.00001 2.22028Z",
    fill: "currentColor"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 7.99999,
    cy: 5.34383,
    rx: 1.53869,
    ry: 1.53865,
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavoritePlace);
export default __webpack_public_path__ + "static/media/favorite-place.e9b6a621987640ee073c21bf1b14ce4e.svg";
export { ForwardRef as ReactComponent };